
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/ai-myths",
      function () {
        return require("private-next-pages/docs/ai-myths.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/ai-myths"])
      });
    }
  